export default function Screen404(props){
    return(
        <div>Coming Soon</div>
    )
}